import React, {useEffect , useState } from "react";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { apiUrl, assetsUrl } from "../config/Config";
import Spinner from "react-activity/dist/Spinner";

const MSczoology = () => {

    const { courseslug } = useParams();
    const [showloading, setshowloding] = useState(false);
    const [coursedetails, setcoursedetails] = useState({});
    const [foldersdata, setfoldersdata] = useState([]);
    // console.log('courseslug >>', courseslug);

    const navigate = useNavigate();

    const viewbatchhandle = (year) => {
        console.log('hello world!!');
        navigate('/course/'+courseslug+'/'+year);
    }

    const fetchcoursedetails = async(course) => {
        var data = {
            courseslug: course
          }
  
          const headers = {
            headers: {
              "Content-Type": "application/json"
            },
          };
  
          let resp = await axios
          .post(apiUrl + "getusercoursedetails", data, headers)
          .then((res) => {
            // console.log('res >>>', res.data)
            if (res.data.status == "success") {
              setshowloding(false);

              if(res?.data?.coursedetail) {
                setcoursedetails(res?.data?.coursedetail);
              } else {
                setcoursedetails({});
              }

              if(res?.data?.folders?.length > 0) {
                setfoldersdata(res?.data?.folders);
              } else {
                setfoldersdata([]);
              }
              
              // window.location.reload();
              
              setshowloding(false);
            } else {
              setshowloding(false);
            }
          })
          .catch((err) => {
            setshowloding(false);
            alert(err.message);
          });
    }

    useEffect(() => {
        if(courseslug) {
            fetchcoursedetails(courseslug)
        }
    }, [courseslug])


    return (
        <div>

            <section className="gallery-main-section">
                <div className="text-center about-tiilte-sec">
                    <p className="about-tiilte-sec-head">{coursedetails?.name ? coursedetails?.name : ""}</p>
                    <p className="about-tiilte-sec-subhead"> home <i class="fa fa-angle-double-right    about-bredcumb-arrow" aria-hidden="true"></i>
                    {coursedetails?.name ? coursedetails?.name : ""}</p>
                </div>
            </section>
            <section className="msc-zoology-main">

                <div className="container">
                    <div className="row">
                        {
                            foldersdata?.length > 0 ?
                            foldersdata?.map((item, index) => {
                                return (
                                  <div className="col-12 col-md-6 col-lg-4 mb-2 mb-md-4" key={index}>
                                    <div className="msc-zoology-content">
                                      <p className="msc-zoology-batchhead">
                                        {item} Batch
                                      </p>
                                      <p className="msc-zoology-viewbtn" style={{cursor: 'pointer'}} onClick={() => {viewbatchhandle(item)}}>
                                        View Batch
                                      </p>
                                    </div>
                                  </div>
                                );
                            }) : 
                            showloading ?
                            <div>
                                 <Spinner color='#264790' size={22} className='spinnerCenter' />
                            </div> :
                            <p className="msc-zoology-batchhead" style={{textAlign: 'center', color: '#000'}}>
                                        No data
                                      </p>
                        }
                        
                    </div>

                </div>
            </section>
        </div>
    )
}
export default MSczoology;